import CommentNewModal from "../modals/comment/CommentNewModal";
import {useState} from "react";
import { useTranslation } from "../../hooks/useTranslation";

export default function Comments({objectId, objectType, comments, callback}) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            {comments?.length === 0 && (<p>{t("comments.noComments")}</p>)}

            {comments?.map((comment, comment_key) => (<div className="card mb-5" key={comment_key}>
                <div className="card-body">
                    <div dangerouslySetInnerHTML={{__html: comment.comment}}/>
                    <strong>{comment.creator_login}</strong>
                    &nbsp;
                    <em>
                        {new Date(comment.created_date_time).toLocaleDateString()}
                        &nbsp;
                        {new Date(comment.created_date_time).toLocaleTimeString()}
                    </em>
                </div>
            </div>))}

            <CommentNewModal show={showModal} handleClose={()=>setShowModal(false)} objectId={objectId} objectType={objectType} callback={callback} />

            <button className="btn btn-primary"
            onClick={()=>setShowModal(true)}
            >
                <i className="ki-duotone ki-plus fs-4 cursor-pointer">
                    <span className="path1"></span>
                    <span className="path2"></span>
                </i>
                {t("comments.addComment")}
            </button>
        </>
    );
}